const MODES = ['light', 'dark', 'system']
const STORAGE_KEY = 'nd_color_mode'

export function getColorMode() {
  return localStorage.getItem(STORAGE_KEY) || 'light'
}

export function setColorMode(mode) {
  localStorage.setItem(STORAGE_KEY, mode)
  window.dispatchEvent(new CustomEvent('nd:colormode', { detail: mode }))
}

export function cycleColorMode() {
  const current = getColorMode()
  const next = MODES[(MODES.indexOf(current) + 1) % MODES.length]
  setColorMode(next)
  return next
}

export function applyColorMode(mode) {
  const systemDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  const isDark = mode === 'dark' || (mode === 'system' && systemDark)
  document.documentElement.classList.toggle('dark', isDark)
}

export const COLOR_MODE_LABELS = { system: 'Auto', light: 'Light', dark: 'Dark' }
